import { isSomething } from "../../utils";

type Props = {
  children?: React.ReactNode;
};

function ActionBarButtons({ children }: Props) {
  const buttons =
    children && (children as $TSFixMe).map ? (
      (children as $TSFixMe)
        .filter((c: $TSFixMe) => isSomething(c) && c !== false)
        .map((button: $TSFixMe) => <li key={button.props.id}>{button}</li>)
    ) : (
      <li>{children}</li>
    );

  return (
    <div className="action-bar">
      <ul>{buttons}</ul>
    </div>
  );
}

export default ActionBarButtons;
